import SMConst from 'lib/SMConst';

class SMReservationHelper {
  
  static isDayTimeConfirmed(reservation){
    if (reservation.rent_type ==  SMConst.RentType.Stay) {
      return false;
    }
    switch (reservation.status) {
      case SMConst.ReservationStatus.Confirmed: 
      case SMConst.ReservationStatus.Paying: 
      case SMConst.ReservationStatus.Paid:
      case SMConst.ReservationStatus.Postpay:
        return true;
    }
    return false;
  }

  static isStayConfirmed(reservation) {
    if (reservation.rent_type !=  SMConst.RentType.Stay) {
      return false;
    }
    switch (reservation.status) {
      case SMConst.ReservationStatus.Confirmed:
      case SMConst.ReservationStatus.Paying:
      case SMConst.ReservationStatus.Paid:
      case SMConst.ReservationStatus.Postpay:
        return true;
    }
    return false;
  }

  static isDayTimeRequested(reservation){
    if (reservation.rent_type ==  SMConst.RentType.Stay) {
      return false;
    }
    switch (reservation.status) {
      case SMConst.ReservationStatus.Sent:
      case SMConst.ReservationStatus.EntrustedOwner:
      case SMConst.ReservationStatus.Requested:
        return true;
    }
    return false;
  }

  static isStayRequested(reservation){
    if (reservation.rent_type !=  SMConst.RentType.Stay) {
      return false;
    }
    switch (reservation.status) {
      case SMConst.ReservationStatus.Sent:
      case SMConst.ReservationStatus.EntrustedOwner:
      case SMConst.ReservationStatus.Requested:
        return true;
    }
    return false;
  }

  static isInquiry(reservation){
    if (reservation.method == SMConst.ReservationMethod.Inquiry) {
      return true;
    }
    return false;
  }
  
  static isBlockSchedule(reservation){
    if (reservation.schedule_type == SMConst.ScheduleType.Disable) {
      return true;
    }
    return false;
  }

  static isImportedSchedule(reservation){
    if (reservation.schedule_type && reservation.schedule_type == SMConst.ScheduleType.Imported) {
      return true;
    }
    return false;
  }
  
  static isOwnerDirect(mediator){
    if (mediator == SMConst.ReservationMediator.OwnerDirect) {
      return true;
    }
    return false;
  }

  static isDetailEditable(reservation) {
    if (!reservation.uid) return true;
    if (this.isInquiry(reservation)) return true;
    return reservation.can_be_edited_detail;
  }

  static isPeriodExtendable(reservation) {
    if (!reservation.uid) return true;
    if (this.isInquiry(reservation)) return true;
    return reservation.can_be_extended_period;
  }

  static isPriceChangeable(reservation) {
    if (!reservation.uid) return true;
    if (this.isInquiry(reservation)) return true;
    return reservation.can_be_changed_price;
  }

  static isCompletedReservation(reservation) {
    switch (reservation.status) {
      case SMConst.ReservationStatus.Paid:
      case SMConst.ReservationStatus.Postpay:
        return true;
    }
    return false;
  }
}
export default SMReservationHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMReservationHelper.js